import type { JobStartDateValue } from 'lib/sdks/jobs-management';
import { JOB_START_DATE } from 'lib/sdks/jobs-management/job.constants';

export const LANGUAGE_WITHIN_2_WEEKS = 'Within 2 weeks';
export const LANGUAGE_WITHIN_1_MONTH = 'Within 1 month';
export const LANGUAGE_IM_FLEXIBLE_ON_THE_START_DATE =
  "I'm flexible on the start date";
export const LANGUAGE_PLANNING = "I'm budgeting / researching";
export const LANGUAGE_ITS_URGENT_48_HOURS = "It's urgent (within 48 hours)";

export type StartDateOption = {
  label: string;
  value: JobStartDateValue;
  level?: 48;
  subheading?: string;
  default?: boolean;
};

export const startDateOptions: StartDateOption[] = [
  {
    label: LANGUAGE_IM_FLEXIBLE_ON_THE_START_DATE,
    value: JOB_START_DATE.flexible,
    default: true,
  },
  {
    label: LANGUAGE_ITS_URGENT_48_HOURS,
    value: JOB_START_DATE.urgent,
    level: 48,
  },
  {
    label: LANGUAGE_WITHIN_2_WEEKS,
    value: JOB_START_DATE.within2Weeks,
  },
  {
    label: LANGUAGE_WITHIN_1_MONTH,
    value: JOB_START_DATE.within1Month,
  },
  {
    label: LANGUAGE_PLANNING,
    value: JOB_START_DATE.inPlanning,
  },
];
